import { useEffect } from "react";
import { createPortal } from "react-dom";

/**
 * ── 변경사항 (모바일 대응) ──
 * 1. createPortal(document.body) — 모달을 페이지 DOM 트리 밖으로.
 *    조상 요소의 overflow/transform에 갇히지 않고 항상 화면 기준으로 뜸.
 * 2. body 스크롤 잠금(overflow만) — touchAction은 portal 내부 터치 스크롤까지 막아서 사용 금지.
 *    (iOS에서 키보드/스크롤 시 모달이 밀려 올라가던 문제 해결)
 * 3. boxSizing: border-box — padding 20px 때문에 화면보다 40px 넓어져
 *    오른쪽이 잘리던 문제 해결.
 */
const Modal = ({ zIndex, children }) => {
  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, []);

  return createPortal(
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(14, 20, 27, 0.45)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: zIndex || 100,
        padding: "20px",
        boxSizing: "border-box",
        overscrollBehavior: "contain",
      }}
    >
      {children}
    </div>,
    document.body
  );
};

export default Modal;
